import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const StyleTabButtonContainer = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  width: fit-content;
  gap: 8px;
  background-color: ${(props: any) => props.theme.colors.white};
  border-radius: 12px;
  padding: 4px 5px;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  max-width: 100%;
  overflow-x: scroll;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    max-width: 98%;
  }
`

export const StyleTabButton = styled.button<{ $active?: boolean }>`
  position: relative;
  border-radius: 8px;
  font-size: 15px;
  letter-spacing: 0.5px;
  border: none;
  background-color: transparent;
  color: ${(props: any) => props.theme.colors.text};
  padding: 10px 16px;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.2s ease;
  flex-shrink: 0;
  z-index: 1;

  &:hover {
    color: ${(props: any) => props.theme.colors.primary};
  }
  ${({ $active, theme }: any) =>
    $active &&
    css`
      border: none;
      color: ${theme.colors.primary};
    `}

  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size: 13px;
  }
`

export const SlidingBackground = styled.div<{
  $width: number
  $left: number
  $shouldAnimate: boolean
}>`
  position: absolute;
  height: calc(100% - 8px);
  top: 4px;
  left: 0;
  background-color: ${(props: any) => props.theme.colors.primaryLight};
  border-radius: 8px;
  width: ${(props) => props.$width}px;
  transform: translateX(${(props) => props.$left}px);
  transition: ${(props) =>
    props.$shouldAnimate ? 'transform 0.3s ease, width 0.3s ease' : 'none'};
  z-index: 0;
`
export const StyleChildrenWrapper = styled.div`
  width: 100%;
  @media (min-width: 768px) {
  }
`
